module.exports = "/images/arrow-back.9ff02da613384820ac7af62bafdb42a9.svg";